import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import {connect} from "react-redux";
import {modalSelector, productSelector} from "../../selectors";
import {toggleModal} from "../../AC/modal";
import {enableThreeDViewer, disableThreeDViewer} from "../../AC/three-d-viewer";
import threeDSettings from "../../../../utils/threejs/three-d-settings";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import NoSsr from "@material-ui/core/NoSsr";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import {withStyles} from "@material-ui/core/styles";
import ThreeDRotationIcon from "@material-ui/icons/ThreeDRotationOutlined";
import ThreeDViewer from "../../../common/ThreeDViewer";
import classNames from "classnames";

const styles = () => ({
  button: {
    "color": `#fff`,
    "boxShadow": `none`,
    "fontWeight": `normal`,
    "textTransform": `none`,
    "backgroundColor": `#52abda`,
    "&:hover": {
      opacity: `.8`,
      backgroundColor: `#52abda`
    }
  }
});

class ThreeDPreivew extends PureComponent {
  static propTypes = {
    product: PropTypes.object,
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    threeDPreview: PropTypes.object,
    classes: PropTypes.object,
    enableThreeDViewer: PropTypes.func,
    disableThreeDViewer: PropTypes.func
  };
  toggleModal = () => {
    this.props.toggleModal(`threeDPreview`);
  };
  render() {
    const {
      product: {
        meta: {product}
      },
      isModalOpen,
      classes
    } = this.props;
    return threeDSettings && threeDSettings[product] ? (
      <div className="three-d-preview">
        <NoSsr>
          <Tooltip title="Посмотреть на 3D модели">
            <Button
              variant="contained"
              onClick={this.toggleModal}
              color="primary"
              className={classNames(classes.button, `three-d-preview__button`)}
            >
              <ThreeDRotationIcon />
              <span style={{marginLeft: `5px`}}>просмотр</span>
            </Button>
          </Tooltip>
        </NoSsr>
        <Modal
          className="editor-modal"
          overlayClassName="editor-modal-overlay"
          isOpen={isModalOpen}
          onRequestClose={this.toggleModal}
        >
          <div className="three-d-viewer-box">
            <ThreeDViewer
              className="three-d-viewer"
              enable={this.props.enableThreeDViewer}
              disable={this.props.disableThreeDViewer}
            />
          </div>
          <button className="editor-modal__close" onClick={this.toggleModal}>
            ×
          </button>
        </Modal>
      </div>
    ) : null;
  }
}

Modal.setAppElement(`body`);

const mapStateToProps = (state) => ({
  isModalOpen: modalSelector(state, `threeDPreview`),
  product: productSelector(state)
});

const mapDispatchToProps = {
  toggleModal,
  enableThreeDViewer,
  disableThreeDViewer
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(withStyles(styles)(ThreeDPreivew)));
